module.exports = __webpack_public_path__ + "static/media/main-bg@2x.e7de9097.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/main-bg@2x.png
// module id = 63
// module chunks = 0